export default __webpack_public_path__ + "pgnv-assets/7dfc6804eed27d99e02da7fa8caae4bb.png";